/* global axios */
import ApiClient from '../ApiClient';

class CopilotActionExecutions extends ApiClient {
  constructor() {
    super('copilot/action_executions', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  undo(id) {
    return axios.post(`${this.url}/${id}/undo`);
  }
}

export default new CopilotActionExecutions();
